import React from 'react';
import translate from '../locales/locales';
import {
    Link
} from "react-router-dom";

function NotFound() {
    return (
        <div className="bgBlue notfound-container">
            <Link to="/"><button className="langSwitch eMedium">{translate.general.home}</button></Link>
            <div className="notFound">
                <p className="white large eMedium">{translate.general.notFound}</p>
            </div>
        </div>
    )
}

export default NotFound;